import Vue from 'vue';
import Vuex from 'vuex';
import about from './modules/about';
import app from './modules/app';
import browse from './modules/browse';
import chart from './modules/chart';
import market from './modules/market';
import overlay from './modules/overlay';
import popup from './modules/popup';
import search from './modules/search';
import support from './modules/support';
import trade from './modules/trade';
import user from './modules/user';
import wallet from './modules/wallet';
import profile from './modules/profile';
import notifications from './modules/notifications';
import insight from './modules/insight';
import dashboard from './modules/dashboard';
import leaderboards from './modules/leaderboards';
import watchlist from './modules/watchlist';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    about,
    app,
    browse,
    chart,
    market,
    overlay,
    popup,
    search,
    support,
    trade,
    user,
    wallet,
    profile,
    notifications,
    insight,
    dashboard,
    leaderboards,
    watchlist,
  },
  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js